import { AppRoutes } from 'constants/routes-paths.constants';

export const getAuditProceedRoute = (id: number) => `${AppRoutes.audits}/${id}/proceed`;
export const getAuditFinishRoute = (id: number) => `${AppRoutes.audits}/${id}/finish`;
